import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {Modal,Box} from '@mui/material';
import { findAllByGroupDetailsEvent } from "../../../_events/orders/find_order.event";
import { message } from "antd";
import Button from "@mui/material/Button";
import InfoOrderModal from "./info_order_modal";
import { Link } from "react-router-dom";
import { APP_ROUTES, MAIN_ROUTES } from "../../../_config/routes";
import { DataGrid } from "@mui/x-data-grid";
import { updateOrderDetailEvent, viewInfoDetailsEvent } from "../../../_events/orderDetail/orderDetail.event";
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,IconButton} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import UpdateOrderDetailModal from './update_orderDetail_modal';
import { findAllColors } from "../../../_events/color/find_colors.event";
import { findAllProcessStateEvent } from "../../../_events/process_state/find_process_state.event";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
};

const OrdersHistory = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openSpecificInfo, setOpenSpecificInfo] = useState(false);
    const [specificInfo, setSpecificInfo] = useState(false);

    const [orderDetailUpdate, setOrderDetailUpdate] = useState(null);
    const [openModalUpdateOD, setOpenModalUpdateOD] = useState(false);

    const [processList, setProcessList] = useState(null);
    const [colorList, setColorList] = useState(null);
    
    const editOrderDetail = (od) => {
      setOpenModalUpdateOD(true);
      findAllColors()
      .then((data)=>{
        setColorList(data.list);
      })
      .catch((err)=>{
        message.error(err)
      })
      findAllProcessStateEvent()
      .then((data)=>{
        setProcessList(data.list);
      })
      .catch((err)=>{
        message.error(err)
      })
      setOrderDetailUpdate(od);
    };

    
    const handleCloseUpdateOrderDetail=()=>{
      setOpenModalUpdateOD(false);
      setOrderDetailUpdate(null);
      setColorList(null);
      setProcessList(null);
    };

    const updateOrderDetail=(dataUpdate)=>{
      updateOrderDetailEvent(dataUpdate,orderDetailUpdate)
      .then((data)=>{
        handleCloseModal();
        if(!data.ok)
        {
          message.error('Error en la actualizacion')
        }else{
          message.success('Registro actualizado')
        }
      })
      .catch((err)=>{
        message.error(err)
      })
    }

    const handleCloseModal = () => {
      setOpenSpecificInfo(false);
      handleCloseUpdateOrderDetail();
    };

    const findOrders = () => {
      findAllByGroupDetailsEvent()
        .then((data) => {
          setOrders(data.list);
          setLoading(false);
        })
        .catch((err) => {
          message.error(err.message);
          setLoading(false);
        });
    };

    const searchSpecificInfo= (uuid_details)=>{
      setOpenSpecificInfo(true);
      viewInfoDetailsEvent(uuid_details)
      .then(data => {
        setSpecificInfo(data.data);
      })
    }
    useEffect(() => {
      findOrders();
    }, []);  
    
    function formatDate(dateTime) {
      if (dateTime) {
        const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Date(dateTime).toLocaleString(undefined, options);
      }
      return '';
    }
    
    const columns = [
        { field: "id", headerName: "Número", width: 100 },
        { field: "date_created", headerName: "Fecha de orden", width: 120 },
        { field: "date_delivery", 
          headerName: "Fecha de entrega", 
          width: 120,
          sortable: false,
          valueGetter: (params) => params.row.date_delivery? params.row.date_delivery : 'INMEDIATA' ,
        },
        {
          field: "state",
          headerName: "Direccion",
          width: 300,
          sortable: false,
          valueGetter: (params) => params.row.address_delivery || "",
        },
        {
          field: "clientName",
          headerName: "Cliente",
          width: 300,
          sortable: false,
          valueGetter: (params) => params.row.ordersDetail[0].productPrice.client.name || "",
        },
        {
          field: "uuid",
          headerName: "Detalle",
          width: 400,
          sortable: false,
          renderCell: (params) => {
            return <InfoOrderModal 
            order={params.row} 
            searchSpecificInfo={(uuid_details)=>searchSpecificInfo(uuid_details)}
            />;
          },
        },
    ];

  return (
    
    <Grid container spacing={1}>
      
      <Grid item xs={12} md={12}>
        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
          <Typography variant="h6" component="h6">
            Historial de pedidos
          </Typography>
          <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.orders_history_group_client}`}>
            <Button style={{ marginLeft: "15px" }} variant="contained" size="small">
              Agrupación cliente
            </Button>
          </Link>
          
        </div>
        <hr />
        {loading ? (
          <div>Loading...</div>
        ) : (
          <div style={{ height: 450, width: "100%" }}>
            <DataGrid
              rows={orders}
              columns={columns}
              pageSize={8}
              disableSelectionOnClick
            />
          </div>
        )}
      </Grid>
 

      <Modal
        open={openSpecificInfo}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {specificInfo ? (
          <>

            <div>
            <b>INFORMACION DETALLADA</b>

            <p> A continuacion vera la informacion de recortes del producto {specificInfo? specificInfo[0].productPrice.product.ref+' del cliente '+specificInfo[0].productPrice.client.name : ''}</p>
            </div>
            
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Producto</TableCell>
                    <TableCell>Color</TableCell>
                    <TableCell>Cantidad</TableCell>
                    <TableCell>Medida</TableCell>
                    <TableCell>Proceso</TableCell>
                    <TableCell>Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {specificInfo.map((od, index) => (
                    <TableRow key={index}>
                      <TableCell>{od.productPrice.product.ref}</TableCell>
                      <TableCell>{od.color.cod}</TableCell>
                      <TableCell>{od.quantity}</TableCell>
                      <TableCell>{od.type_quantity}</TableCell>
                      <TableCell>{od.cod_process}</TableCell>
                      <TableCell>
                      <IconButton size='small' color="primary"  onClick={() => { 
                          editOrderDetail(od)
                          }}>
                        <EditIcon /> 
                      </IconButton>  
                      </TableCell>
                      
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            </>
          ) : (
            'Cargando....'
          )}
        </Box>
      </Modal>
      

      <UpdateOrderDetailModal
        openModalUpdateOD={openModalUpdateOD}
        orderDetailUpdate={orderDetailUpdate}
        handleCloseUpdateOrderDetail={handleCloseUpdateOrderDetail}
        updateOrderDetail={(body) => updateOrderDetail(body)}
        processList={processList}
        colorList={colorList}
        
      />   

    </Grid>
    

  );
};

export default OrdersHistory;
